import React from 'react';

/**
 * Component to render Bible text with clickable Strong's numbers
 * Parses text like: "For <w s='G2316'>God</w> so <w s='G25'>loved</w>"
 * And displays as: "For God^G2316 so loved^G25"
 */
const StrongsText = ({ text, onStrongsClick }) => {
  if (!text) return null;

  // Check if text has Strong's tags
  const hasStrongs = text.includes("<w s=");

  if (!hasStrongs) {
    return <span>{text}</span>;
  }

  // Parse the text and extract words with Strong's numbers
  const parts = [];
  let currentIndex = 0;
  const regex = /<w s='([^']+)'>([^<]+)<\/w>/g;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > currentIndex) {
      parts.push({
        type: 'text',
        content: text.substring(currentIndex, match.index)
      });
    }

    // Add the Strong's word
    parts.push({
      type: 'strongs',
      strongsId: match[1],
      word: match[2]
    });

    currentIndex = regex.lastIndex;
  }

  // Add remaining text
  if (currentIndex < text.length) {
    parts.push({
      type: 'text',
      content: text.substring(currentIndex)
    });
  }

  return (
    <span>
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <span key={index}>{part.content}</span>;
        } else {
          return (
            <span key={index} className="inline-block">
              {part.word}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  onStrongsClick(part.strongsId);
                }}
                className="ml-0.5 text-xs font-mono text-blue-600 hover:text-blue-800 hover:underline cursor-pointer align-super transition-colors"
                title={`Click to see Strong's ${part.strongsId} definition`}
              >
                {part.strongsId}
              </button>
            </span>
          );
        }
      })}
    </span>
  );
};

export default StrongsText;
